var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Envelope",
    clipPath: "url(#clip0_36_1607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 3.75H2.5C2.16848 3.75 1.85054 3.8817 1.61612 4.11612C1.3817 4.35054 1.25 4.66848 1.25 5V15C1.25 15.3315 1.3817 15.6495 1.61612 15.8839C1.85054 16.1183 2.16848 16.25 2.5 16.25H17.5C17.8315 16.25 18.1495 16.1183 18.3839 15.8839C18.6183 15.6495 18.75 15.3315 18.75 15V5C18.75 4.66848 18.6183 4.35054 18.3839 4.11612C18.1495 3.8817 17.8315 3.75 17.5 3.75ZM2.5 2.5C1.83696 2.5 1.20107 2.76339 0.732233 3.23223C0.263392 3.70107 0 4.33696 0 5L0 15C0 15.663 0.263392 16.2989 0.732233 16.7678C1.20107 17.2366 1.83696 17.5 2.5 17.5H17.5C18.163 17.5 18.7989 17.2366 19.2678 16.7678C19.7366 16.2989 20 15.663 20 15V5C20 4.33696 19.7366 3.70107 19.2678 3.23223C18.7989 2.76339 18.163 2.5 17.5 2.5H2.5Z",
    fill: "#6675FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0887212 5.30378C0.130898 5.23335 0.186537 5.17192 0.252461 5.12299C0.318385 5.07407 0.393302 5.03861 0.472932 5.01864C0.552562 4.99868 0.635346 4.9946 0.716554 5.00663C0.797762 5.01866 0.875804 5.04658 0.946221 5.08878L9.99997 10.5213L19.0537 5.08878C19.1241 5.0466 19.2022 5.01869 19.2834 5.00667C19.3646 4.99464 19.4474 4.99872 19.527 5.01869C19.6066 5.03865 19.6815 5.07411 19.7475 5.12302C19.8134 5.17194 19.869 5.23336 19.9112 5.30378C19.9534 5.3742 19.9813 5.45224 19.9933 5.53345C20.0054 5.61465 20.0013 5.69743 19.9813 5.77706C19.9613 5.85669 19.9259 5.9316 19.877 5.99753C19.8281 6.06345 19.7666 6.1191 19.6962 6.16128L9.99997 11.9788L0.303721 6.16253C0.233289 6.12036 0.171855 6.06472 0.12293 5.99879C0.0740055 5.93287 0.0385476 5.85795 0.018582 5.77832C-0.00138365 5.69869 -0.0054657 5.61591 0.00656898 5.5347C0.0186037 5.45349 0.0465193 5.37545 0.0887212 5.30503V5.30378Z",
    fill: "#6675FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.44 11.165L8.98 10.85L8.35 9.77002L7.81 10.085L8.44 11.165ZM0.939998 15.54L8.44 11.165L7.81 10.085L0.309998 14.46L0.939998 15.54ZM11.56 11.165L11.02 10.85L11.65 9.77002L12.19 10.085L11.56 11.165ZM19.06 15.54L11.56 11.165L12.19 10.085L19.69 14.46L19.06 15.54Z",
    fill: "#6675FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_1607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailB);
export default __webpack_public_path__ + "static/media/mailB.3c2e9fb8b23c9b45147d7f9ca7d6add8.svg";
export { ForwardRef as ReactComponent };